export const SORT_ORDER = {
  asc: 'asc',
  desc: 'desc',
};
